import typographyFonts from './typographyFonts';
import breakpoints from './breakpoints';

export default {
  typographyFonts,
  breakpoints,
  fontFamily: 'Mulish, sans-serif',
  transition: '200ms ease-in-out',
  borderRadius: '8px',
};
